import Loading from '../../../../Dashboards/Common/Loading';
import {
    ServicesPerYearTotal
} from '../../../Common/Services/charts/apex-charts';
import { ServicesPerMonthPerYearCompare } from '../../../Common/Services/charts/apex-charts/ServicesPerMonthPerYearCompare';
import { useServicesChartsDataContext } from '../../../Common/Services/hooks/useServicesChartsDataContext';
import { Total } from './Total';

const GeneralResultsAIH = () => {
    const { isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <Total />
            <div className="charts-side-by-side-dashboards">
                <ServicesPerYearTotal />
                <ServicesPerMonthPerYearCompare />
            </div>
        </>
    );
};

export default GeneralResultsAIH;
